import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';
import useBookedLessons from 'src/hooks/useBookedLessons';
import usePurchasedSubscriptions from 'src/hooks/usePurchasedSubscriptions';
import Page from 'src/layout/Page';
import './personal.css';
import { useTranslation } from 'react-i18next';

const Personal: React.FC = (): React.ReactElement => {
  const [userInfo, setUserInfo] = useState<any>();
  const navigate = useNavigate();
  const { purchasedSubscriptions } = usePurchasedSubscriptions();
  const { bookedLessons } = useBookedLessons({ lessonType: 'past' });
  const { t, i18n } = useTranslation();

  const { isAuthenticated } = useAuth();

  useEffect(() => {
    document.title = t('pages.personal.title');
  }, [i18n.language]);

  useEffect(() => {
    const authUser = JSON.parse(localStorage.getItem('user') || '');
    setUserInfo(authUser);
  }, []);

  const handleAdditionalSubscription = (e: any) => {
    e.preventDefault();
		if (i18n.language !== 'en') {
			navigate('/רישום');
		} else {
			navigate('/en/subscribe');
		}
  };

  const handleMyTimesheet = (e: any) => {
    e.preventDefault();
		if (i18n.language !== 'en') {
			navigate('/מערכת');
		} else {
			navigate('/en/timesheet');
		}
  };

  useEffect(() => {
    if (!isAuthenticated()) {
			if (i18n.language !== 'en') {
				navigate('/ְּנִיסָה-לַמַעֲרֶכֶת');
			} else {
				navigate('/en/login');
			}
    }
  }, [isAuthenticated]);

  const getStudiedLessons = () => {
    const lessons: number[] = [];
    const children: number[] = [];
    const booked: any = [];
    bookedLessons.map((bLesson: any) => {
      if (
        lessons.indexOf(bLesson.lessonId) !== -1
        && children.indexOf(bLesson.childId) !== -1
      ) {
        return bLesson;
      }
      lessons.push(bLesson.lessonId);
      children.push(bLesson.childId);
      booked.push(bLesson);
      return bLesson;
    });
    return booked.map((bookedLesson: any, index: number) => (
      <div key={`bookedLesson-${index}`} className={'green'}>
        {`${bookedLesson.lessonName} [${bookedLesson.firstName} ${bookedLesson.lastName}]`}
      </div>
    ));
  };

  return (
    <Page
      pageClass={'personal-page'}
	  pageHeader={`${t('pages.personal.hello')} ${userInfo?.name?.trim() || userInfo?.firstName}!`}    >
      <>
        {purchasedSubscriptions && purchasedSubscriptions?.length >= 0 && (
          <>
            <div className="subscriptions-info">
              {purchasedSubscriptions?.map((subscription) => (
                <React.Fragment key={subscription.id}>
                  <div className={'subscription'}>
                    <div className="type">
                      <div>{t('pages.personal.subscriptionType')}</div>
                      <button className={'pink'}>
                        {subscription.lessonsCountInitial} {t('pages.personal.lessons')}
                      </button>
                    </div>
                  </div>
                  <div className="monthly-balance">
                    {t('pages.personal.remainingLessons')}
                    <button className="yellow">
                      {subscription.lessonsCountLeft} {t('pages.personal.lessons')}
                    </button>
                    {t('pages.personal.toBeUsed')}
                  </div>
                </React.Fragment>
              ))}
              {purchasedSubscriptions
                && purchasedSubscriptions?.length > 0
                && bookedLessons.length > 0 && (
                  <div className="you-study">
                    <div className="title">{t('pages.personal.studied')}</div>
                    <div className="courses">
                      {getStudiedLessons()}
                    </div>
                  </div>
              )}
            </div>
            <div className="action-buttons">
              <button
                className={'active continue-subscribe'}
                onClick={handleAdditionalSubscription}
              >
                {t('pages.personal.purchaseAdditionalSubscription')}
              </button>
              {purchasedSubscriptions && purchasedSubscriptions.length > 0 && (
                <button
                  className={'active continue-subscribe'}
                  onClick={handleMyTimesheet}
                >
                  {t('pages.personal.myTimesheet')}
                </button>
              )}
            </div>
          </>
        )}
      </>
    </Page>
  );
};

export default Personal;
